import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...args: ClassValue[]) {
  return twMerge(clsx(args))
}

export function tw(strings, ...values) {
  return String.raw({ raw: strings }, ...values)
}
